import { Document } from '@/shared/api/transcriptor/transcriptorApi';

import { NO_SPEECH_DETECTED_ERROR, TranscriptorConsultation } from '../config';

export const isNoSpeechDetectedError = (error?: string | null): boolean =>
  error?.toLowerCase() === NO_SPEECH_DETECTED_ERROR;

export const isNoSpeechSkippedDocument = (
  document?: Document | null,
): boolean =>
  Boolean(
    document &&
      document.status === 'skipped' &&
      isNoSpeechDetectedError(document.error),
  );

/**
 * Whole-recording check: processing completed and either every document was
 * skipped with the no-speech reason, or the encounter itself carries the
 * marker (list previews expose only the encounter-level error). The UI renders
 * exactly one notification per recording.
 */
export const hasNoSpeechDetected = (
  consultation?: Pick<
    TranscriptorConsultation,
    'status' | 'documents' | 'error'
  > | null,
): boolean => {
  const documents = consultation?.documents ?? [];
  const documentsNoSpeech =
    documents.length > 0 && documents.every(isNoSpeechSkippedDocument);
  const encounterNoSpeech = isNoSpeechDetectedError(consultation?.error);
  return Boolean(
    consultation &&
      consultation.status === 'succeeded' &&
      (documentsNoSpeech || encounterNoSpeech),
  );
};
